import { Injectable } from '@angular/core';
import { BaseApiClientEmployeesService } from './base-api-client-employees.service';

@Injectable({
  providedIn: 'root'
})
export class ApiClientEmployeesService extends BaseApiClientEmployeesService {}
